export const TEMPLATE_TYPES = [
  { value: "psps", label: "PSPS" },
  { value: "pla", label: "PLA" },
  { value: "mg", label: "MG" },
  { value: "mg_pla", label: "MG PLA" },
  { value: "mbl", label: "MBL" },
];

/** Email outbound test does not support PLA template type */
export const TEMPLATE_TYPES_EMAIL = TEMPLATE_TYPES.filter(
  (t) => t.value !== "pla" && t.value !== "mg_pla",
);

export const LANGUAGES = [
  { value: "arabic", label: "Arabic" },
  { value: "chin_cantonese", label: "Chinese (Cantonese)" },
  { value: "chin_mandarin", label: "Chinese (Mandarin)" },
  { value: "english", label: "English" },
  { value: "farsi", label: "Farsi" },
  { value: "hindi", label: "Hindi" },
  { value: "hmong", label: "Hmong" },
  { value: "japanese", label: "Japanese" },
  { value: "khmer", label: "Khmer" },
  { value: "korean", label: "Korean" },
  { value: "portuguese", label: "Portuguese" },
  { value: "punjabi", label: "Punjabi" },
  { value: "russian", label: "Russian" },
  { value: "spanish", label: "Spanish" },
  { value: "tagalog", label: "Tagalog" },
  { value: "thai", label: "Thai" },
  { value: "vietnamese", label: "Vietnamese" },
];
